(() => {
  const sounds = [
    { word: 'POW!', variant: 'pow' },
    { word: 'BAM!', variant: 'bam' },
    { word: 'ZAP!', variant: 'zap' },
    { word: 'BOOM!', variant: 'boom' },
    { word: 'WHOOSH!', variant: 'whoosh' }
  ];

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileView = window.matchMedia('(max-width: 800px)');
  let navigating = false;
  let lastPointer = null;

  const resetRestoredPageState = () => {
    navigating = false;
    lastPointer = null;
    document.querySelectorAll('.gc-comic-transition').forEach(element => element.remove());
    document.querySelectorAll('.gc-selected-highlight').forEach(element => element.classList.remove('gc-selected-highlight'));
  };

  window.addEventListener('pagehide', () => {
    resetRestoredPageState();
  });

  window.addEventListener('pageshow', () => {
    resetRestoredPageState();
  });

  const rememberPointer = (x, y) => {
    if (!Number.isFinite(x) || !Number.isFinite(y)) return;
    lastPointer = { x, y, at: performance.now() };
  };

  document.addEventListener('pointerdown', event => {
    rememberPointer(event.clientX, event.clientY);
  }, { capture: true, passive: true });

  document.addEventListener('touchstart', event => {
    const touch = event.touches && event.touches[0];
    if (touch) rememberPointer(touch.clientX, touch.clientY);
  }, { capture: true, passive: true });

  const selectionTarget = source => {
    if (!(source instanceof Element)) return null;

    const directControl = source.closest(
      'button:not([disabled]), [role="button"]:not([aria-disabled="true"]), input[type="button"]:not([disabled]), input[type="submit"]:not([disabled]), summary'
    );
    if (directControl) return directControl;

    const productCard = source.closest('.product-card');
    if (productCard && source.closest('.product-card__link')) return productCard;

    const publisherCard = source.closest('.publisher-card');
    if (publisherCard) return publisherCard;

    const carouselCard = source.closest('.carousel-card');
    if (carouselCard) return carouselCard;

    const link = source.closest('a[href]');
    if (link) return link;

    const labelledControl = source.closest('label[for]');
    if (labelledControl) return labelledControl;

    return null;
  };

  const showSelectionHighlight = target => {
    if (!target || reducedMotion.matches) return;
    if (target.matches('[disabled],[aria-disabled="true"]')) return;

    target.classList.remove('gc-selected-highlight');
    void target.offsetWidth;
    target.classList.add('gc-selected-highlight');

    window.setTimeout(() => {
      target.classList.remove('gc-selected-highlight');
    }, 420);
  };

  const isModifiedClick = event =>
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey;

  const shouldTransition = (anchor, event) => {
    if (!anchor || navigating || reducedMotion.matches || isModifiedClick(event)) return false;
    if (event.defaultPrevented) return false;
    if (anchor.hasAttribute('download') || anchor.target === '_blank') return false;
    if (anchor.matches('[data-no-comic-transition]')) return false;

    const href = anchor.getAttribute('href');
    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:')
    ) return false;

    let url;
    try {
      url = new URL(anchor.href, window.location.href);
    } catch (_) {
      return false;
    }

    if (url.origin !== window.location.origin) return false;
    if (url.href === window.location.href) return false;

    return true;
  };

  const effectPosition = event => {
    const clickHasPointer =
      Number.isFinite(event.clientX) &&
      Number.isFinite(event.clientY) &&
      (event.clientX !== 0 || event.clientY !== 0);

    const recentPointer =
      lastPointer &&
      (performance.now() - lastPointer.at) < 1200;

    let x;
    let y;

    if (mobileView.matches && recentPointer) {
      x = lastPointer.x;
      y = lastPointer.y;
    } else if (clickHasPointer) {
      x = event.clientX;
      y = event.clientY;
    } else if (recentPointer) {
      x = lastPointer.x;
      y = lastPointer.y;
    } else {
      x = window.innerWidth / 2;
      y = window.innerHeight / 2;
    }

    const horizontalPadding = mobileView.matches ? 100 : 90;
    const verticalPadding = mobileView.matches ? 78 : 90;

    return {
      x: Math.max(horizontalPadding, Math.min(window.innerWidth - horizontalPadding, x)),
      y: Math.max(verticalPadding, Math.min(window.innerHeight - verticalPadding, y))
    };
  };

  const showEffect = event => {
    document.querySelectorAll('.gc-comic-transition').forEach(element => element.remove());

    const sound = sounds[Math.floor(Math.random() * sounds.length)];
    const position = effectPosition(event);
    const rotation = Math.round((Math.random() * 14) - 7);

    const burst = document.createElement('div');
    burst.className = 'gc-comic-transition gc-comic-transition--' + sound.variant;
    burst.setAttribute('aria-hidden', 'true');
    burst.style.setProperty('--gc-burst-x', position.x + 'px');
    burst.style.setProperty('--gc-burst-y', position.y + 'px');
    burst.style.setProperty('--gc-burst-rotation', rotation + 'deg');
    burst.innerHTML =
      '<span class="gc-comic-transition__burst">' +
        '<span class="gc-comic-transition__word">' + sound.word + '</span>' +
      '</span>';

    document.body.appendChild(burst);
    window.setTimeout(() => burst.remove(), 420);
  };

  document.addEventListener('pointerdown', event => {
    const target = selectionTarget(event.target);
    showSelectionHighlight(target);
  }, { capture: true, passive: true });

  document.addEventListener('click', event => {
    if (event.detail === 0) {
      const target = selectionTarget(event.target);
      showSelectionHighlight(target);
    }
  }, { capture: true });

  document.addEventListener('click', event => {
    const anchor = event.target.closest && event.target.closest('a[href]');
    if (!shouldTransition(anchor, event)) return;

    event.preventDefault();
    navigating = true;

    const destination = anchor.href;
    showEffect(event);

    window.setTimeout(() => {
      window.location.assign(destination);
    }, 215);
  });
})();